import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    formGroup: {
      borderRadius: '0.5rem',
      padding: '0.8rem',
      marginBottom: '1.6rem',

      '& > .MuiTypography-body1': {
        fontSize: '1.4rem',
      },
      '& > .MuiTypography-subtitle2': {
        fontSize: '1.2rem',
        color: '#727970',
      },
      '& .MuiTypography-subtitle1': {
        FontSize: '1.2rem',
      },
      '& .MuiCheckbox-root': {
        color: '#646464',

        '&.Mui-checked, &.MuiCheckbox-indeterminate': {
          color: theme.palette.primary.dark,
        },
      },
      '& .MuiRadio-root': {
        color: '#646464',

        '&.Mui-checked': {
          color: theme.palette.primary.dark,
        },
      },
    },
    border: {
      border: '1px solid #ABABAB',
    },
    borderError: {
      border: `1px solid ${theme.palette.error.main}`,
    },
    errorMessage: {
      fontSize: '1.1rem',
      color: theme.palette.error.main,
      marginBottom: '1.6rem',
    },
  }),
)
